/**
 * Tenant user dashboard BFF — home overview, merged profile.
 */

import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

export async function getHomeOverview() {
  const data = await tenantApiFetch(tenantDashboardPath("/home/overview"));
  return { data };
}

export async function getTenantMe() {
  const data = await tenantApiFetch(tenantDashboardPath("/me"));
  return { data };
}
